import * as t from 'io-ts';
import { NonEmptyString } from 'io-ts-types';
import { fromEnum } from '../responseUtil';

export const TermsAndConditionsAgreementCodec = t.type({
    accepted: t.boolean,
});

export enum ApiSupplier {
    VW = 'vw',
    RIO_INTERNAL = 'rio-internal',
    RIO_MONITORING = 'rio-monitoring',
}

export enum ApiFeatureActivationStatus {
    APPROVED = 'approved',
    PENDING = 'pending',
    NONE = 'none',
}

export enum ApiCompoundAccess {
    ACCESS = 'access',
    NO_ACCESS = 'no-access',
}

export const SupplierCodec = fromEnum<ApiSupplier>('ApiSupplier', ApiSupplier);

export const FeatureCodec = t.type({
    activation_status: fromEnum<ApiFeatureActivationStatus>('ApiFeatureActivationStatus', ApiFeatureActivationStatus),
    compound: fromEnum<ApiCompoundAccess>('ApiCompoundAccess', ApiCompoundAccess),
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ActivationRequestCodec = t.intersection([
    t.type({
        supplier: t.literal(ApiSupplier.VW),
        service_provider_identification: NonEmptyString,
        duns: NonEmptyString,
        interface_access_requested: t.boolean,
    }),
    t.partial({
        phone: NonEmptyString,
    }),
]);

export type ApiActivationRequest = t.TypeOf<typeof ActivationRequestCodec>;
export type ApiTermsAndConditionsAgreement = t.TypeOf<typeof TermsAndConditionsAgreementCodec>;
export type ApiFeatures = t.TypeOf<typeof FeatureCodec>;
